import { WEBGATE_DOMAIN } from '@mrkt/features/webgate-fetch';

export const fundraisingServiceUrl = `${WEBGATE_DOMAIN}/artist-fundraising-pick`;

export const fundraisingLinkValidationMsg =
  'Make sure your fundraising link is valid and matches the provider you chose';

export const reliefOrgValidationMsg =
  'You must choose a Music Relief organization';

export const termsAndConditionsUrl =
  'https://www.spotify.com/legal/artist-fundraising-pick-terms';

export const faqUrl =
  'https://artists.spotify.com/faq/profile#get-support-during-covid-19';

export const programPoliciesUrl =
  'https://artists.spotify.com/faq/profile#fundraising-pick-policies';

export const musicReliefOrgsUrl =
  'https://covid19musicrelief.byspotify.com/en-us';

export const blogPostUrl =
  'https://artists.spotify.com/blog/best-practices-for-the-artist-fundraising-pick';

export const musicReliefOrgLinks = {
  afac: 'https://www.givingloop.org/afac?p_id=113',
  cnv:
    'https://www.cnv.fr/centre-national-musique-et-spotify-france-au-secours-artistes-et-professionnels-musique-et-varietes',
  deutscheorchesterstifftung: 'https://orchesterstiftung.de/nothilfefonds/',
  fonutovendekunstnere:
    'https://www.ffuk.no/spotify-covid-19-music-relief.6305949-60435.html',
  helpmusicians: 'https://www.helpmusicians.org.uk/spotifyrelief',
  initiativemusik: 'https://www.initiative-musik.de/music-relief/',
  irishmusicindustryrelief:
    'https://www.firstmusiccontact.com/irish-music-industry-relief-fund/spotify-relief',
  musicamexico: 'https://musicamexicocovid19.com/spotifyrelief/',
  musicares:
    'https://www.grammy.com/musicares/donations?utm_source=Spotify&utm_medium=partner&utm_campaign=Spotifycovid19',
  musicinnovationhub:
    'https://www.musicinnovationhub.org/progetti/covid-19-sosteniamo-la-musica',
  musichealthalliance: 'https://www.musichealthalliance.com/spotify/',
  musichelps:
    'https://givealittle.co.nz/cause/covid-19-support-for-kiwi-music-people?utm_source=Spotify&utm_medium=partner&utm_campaign=Spotifycovid19',
  musikerforbundet: 'https://krisfond.musikerforbundet.se/donations',
  neworleansjazzheritage: 'https://www.gofundme.com/f/jazzandheritagespotify',
  noodfundsmuziek: 'https://www.noodfondsmuziek.nl/spotify',
  preservationhallfoundation:
    'https://www.preshallfoundation.org/spotify-music-relief',
  prsfoundation: 'https://www.prsfoundation.com/spotifyrelief',
  supportact:
    'https://supportact.org.au/give-help/spotify-covid-19-music-relief-appeal/',
  ubc: 'https://spotifyrelief.ubc.org.br/',
  uniondemusicosindependientes:
    'https://donaronline.org/union-de-musicxs-independientes/umi-spotify',
  unisonfund: 'https://unisonfund.ca/donations/spotify',
} as const;

export const musicReliefOrgDisplayNames: {
  [K in keyof typeof musicReliefOrgLinks]: string;
} = {
  afac: 'The Arab Fund for Arts and Culture',
  cnv: 'Centre National de la Musique',
  deutscheorchesterstifftung: 'Deutsche Orchester-Stiftung',
  fonutovendekunstnere: 'Fond for utøvende kunstnere',
  helpmusicians: 'Help Musicians',
  initiativemusik: 'Initiative Musik',
  irishmusicindustryrelief: 'Irish Music Industry Relief',
  musicamexico: 'Música México COVID-19',
  musicares: 'MusiCares',
  musicinnovationhub: 'Music Innovation Hub',
  musichealthalliance: 'Music Health Alliance',
  musichelps: 'MusicHelps',
  musikerforbundet: 'Musikerförbundet',
  neworleansjazzheritage:
    'The New Orleans Jazz & Heritage Festival & Foundation, Inc.',
  noodfundsmuziek: 'Noodfunds Muziek',
  preservationhallfoundation: 'Preservation Hall Foundation',
  prsfoundation: 'PRS Foundation',
  supportact: 'Support Act',
  ubc: 'UBC (Brazilian Union of Composers)',
  uniondemusicosindependientes: 'La Unión de Músicxs Independientes',
  unisonfund: 'Unison Benevolent Fund',
} as const;

export const musicReliefOrgDisplayNamesWithCountries: {
  [K in keyof typeof musicReliefOrgLinks]: string;
} = {
  afac: 'The Arab Fund for Arts and Culture (LB)',
  cnv: 'Centre National de la Musique (FR)',
  deutscheorchesterstifftung: 'Deutsche Orchester-Stiftung (DE)',
  fonutovendekunstnere: 'Fond for utøvende kunstnere (NO)',
  helpmusicians: 'Help Musicians (UK)',
  initiativemusik: 'Initiative Musik (DE)',
  irishmusicindustryrelief: 'Irish Music Industry Relief (IE)',
  musicamexico: 'Música México COVID-19 (MX)',
  musicares: 'MusiCares (US)',
  musicinnovationhub: 'Music Innovation Hub (IT)',
  musichealthalliance: 'Music Health Alliance (US)',
  musichelps: 'MusicHelps (NZ)',
  musikerforbundet: 'Musikerförbundet (SE)',
  neworleansjazzheritage:
    'The New Orleans Jazz & Heritage Festival & Foundation, Inc. (US)',
  noodfundsmuziek: 'Noodfunds Muziek (NL)',
  preservationhallfoundation: 'Preservation Hall Foundation (US)',
  prsfoundation: 'PRS Foundation (UK)',
  supportact: 'Support Act (AU)',
  ubc: 'UBC (Brazilian Union of Composers) (BR)',
  uniondemusicosindependientes: 'La Unión de Músicxs Independientes (AR)',
  unisonfund: 'Unison Benevolent Fund (CA)',
} as const;
